/* Pawgrip free gift + homepage extras.
   - Keeps exactly one free toy in the cart whenever there are 3+ sets of socks,
     and removes it if the socks drop below 3 (drawer, cart page or buy box).
     The toy is picked AT RANDOM from the in-stock variants listed in
     snippets/sp-gift-config.liquid; if that one fails to add, the next is tried.
     The price is taken off by the automatic discount "Free toy with 3 sets".
   - Sticky quick-buy bar and gentle scroll reveals on the homepage.
   Uses Shopify's own cart and Horizon's own drawer; no second cart system. */
(function(){
  if(window.spGift)return;
  var cfg=window.spGiftCfg||{};
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  var _f=window.fetch.bind(window);
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function j(u,o){
    o=o||{};
    o.headers={'Content-Type':'application/json','Accept':'application/json'};
    return _f(root+u,o).then(function(r){if(!r.ok)throw new Error('cart');return r.json();});
  }

  /* The gift pool, shuffled so every in-stock toy has an equal chance. */
  function pool(){
    var p=(cfg.variants&&cfg.variants.length)?cfg.variants.slice():(cfg.variant?[cfg.variant]:[]);
    for(var i=p.length-1;i>0;i--){var k=Math.floor(Math.random()*(i+1));var t=p[i];p[i]=p[k];p[k]=t;}
    return p;
  }
  function addGift(list){
    if(!list.length)return Promise.resolve(false);
    return j('cart/add.js',{method:'POST',body:JSON.stringify({items:[{id:list[0],quantity:1,properties:{'Free gift':'Included with 3 sets'}}]})})
      .then(function(){return true;})
      .catch(function(){return addGift(list.slice(1));});
  }

  var inflight=null;
  function sync(){
    if(!pool().length||!cfg.sockProduct||!cfg.giftProduct)return Promise.resolve(false);
    if(inflight)return inflight;
    inflight=j('cart.js').then(function(cart){
      var socks=0,gifts=[];
      cart.items.forEach(function(it){
        if(it.product_id===cfg.sockProduct)socks+=it.quantity;
        else if(it.product_id===cfg.giftProduct)gifts.push(it);
      });
      var want=socks>=(cfg.min||3);
      var ok=want?(gifts.length===1&&gifts[0].quantity===1):gifts.length===0;
      if(ok)return false;
      var step=Promise.resolve();
      if(gifts.length){
        var up={};
        gifts.forEach(function(g){up[g.key]=0;});
        step=j('cart/update.js',{method:'POST',body:JSON.stringify({updates:up})});
      }
      return step.then(function(){
        if(!want)return true;
        return addGift(pool()).then(function(){return true;});
      });
    }).catch(function(){return false;}).then(function(changed){inflight=null;return changed;});
    return inflight;
  }

  function bubble(count){
    try{sessionStorage.setItem('cart-count',JSON.stringify({value:String(count),timestamp:Date.now()}));}catch(e){}
    document.querySelectorAll('cart-icon').forEach(function(icon){
      if(typeof icon.renderCartBubble==='function'){try{icon.renderCartBubble(count);return;}catch(e){}}
      var n=icon.querySelector('.cart-bubble__text-count');
      var b=icon.querySelector('.cart-bubble');
      if(n){n.textContent=count<100?String(count):'';n.classList.toggle('hidden',count===0);}
      if(b)b.classList.toggle('visually-hidden',count===0);
    });
  }

  function refreshUI(){
    if(document.body.classList.contains('template-cart')){window.location.reload();return Promise.resolve();}
    var p1=j('cart.js').then(function(c){bubble(c.item_count);});
    var inner=document.querySelector('#cart-drawer .cart-drawer__inner');
    var p2=!inner?null:_f(root+'?sections=cart-drawer-section',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(d){
        var html=d&&d['cart-drawer-section'];if(!html)return;
        var h=document.createElement('div');h.innerHTML=html;
        var fresh=h.querySelector('.cart-drawer__inner');if(!fresh)return;
        inner.className=fresh.className;inner.innerHTML=fresh.innerHTML;
      });
    return Promise.all([p1,p2]).catch(function(){});
  }

  /* Watch the theme's own cart requests (drawer +/-, remove, cart page). */
  window.fetch=function(input,init){
    var url=String((input&&input.url)||input||'');
    var p=_f(input,init);
    if(/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)){
      p.then(function(r){
        if(!r.ok)return;
        setTimeout(function(){sync().then(function(c){if(c)refreshUI();});},60);
      }).catch(function(){});
    }
    return p;
  };

  /* The toy photo flies from its bubble to the basket icon. */
  function fly(from){
    if(reduced||!from||!cfg.img||!Element.prototype.animate)return;
    var icon=document.querySelector('cart-icon')||document.querySelector('a[href$="/cart"]');
    if(!icon)return;
    var a=from.getBoundingClientRect(),b=icon.getBoundingClientRect();
    if(!a.width||!b.width)return;
    var img=document.createElement('img');
    img.src=cfg.img;img.alt='';img.className='sp-gift-fly';img.setAttribute('aria-hidden','true');
    img.style.cssText='left:'+a.left+'px;top:'+a.top+'px;width:'+a.width+'px;height:'+a.height+'px';
    document.body.appendChild(img);
    var dx=b.left+b.width/2-(a.left+a.width/2),dy=b.top+b.height/2-(a.top+a.height/2);
    var anim=img.animate([
      {transform:'translate(0,0) scale(1)',opacity:1},
      {transform:'translate('+(dx*.45)+'px,'+(dy*.45-90)+'px) scale(.85) rotate(-14deg)',opacity:1,offset:.45},
      {transform:'translate('+dx+'px,'+dy+'px) scale(.22) rotate(10deg)',opacity:.15}
    ],{duration:950,easing:'cubic-bezier(.5,0,.3,1)'});
    anim.onfinish=function(){img.remove();icon.classList.remove('sp-bump');void icon.offsetWidth;icon.classList.add('sp-bump');};
  }

  function sticky(){
    var buy=document.querySelector('[data-sp-buy]');
    if(!buy||!('IntersectionObserver' in window))return;
    var bar=document.createElement('div');
    bar.className='sp-sticky';
    bar.setAttribute('role','region');
    bar.setAttribute('aria-label','Quick buy');
    bar.innerHTML='<div class="sp-sticky__tx"><b>Pawgrip grip socks</b><span data-sp-sticky-p></span></div><button type="button" class="sp-sticky__btn">Choose your set</button>';
    document.body.appendChild(bar);
    var line=bar.querySelector('[data-sp-sticky-p]');
    var src=buy.querySelector('[data-sp-btnprice]');
    function syncLine(){
      var p=src?src.textContent.trim():'';
      line.textContent=buy.classList.contains('is-gift-on')?p+' \u00b7 free toy included':p+' \u00b7 free toy with 3 sets';
    }
    syncLine();
    buy.addEventListener('change',function(){setTimeout(syncLine,40);});
    new IntersectionObserver(function(es){
      var e=es[0];
      bar.classList.toggle('is-on',!e.isIntersecting&&e.boundingClientRect.top<0);
    },{threshold:0}).observe(buy);
    bar.querySelector('button').addEventListener('click',function(){
      var y=buy.getBoundingClientRect().top+window.scrollY-110;
      window.scrollTo({top:y,behavior:reduced?'auto':'smooth'});
    });
  }

  function reveal(){
    if(reduced||!('IntersectionObserver' in window)||!document.querySelector('[data-sp-buy]'))return;
    var els=[].slice.call(document.querySelectorAll('[id$="__sp_why"] h2,.sp-serif p,.sp-panel,[id$="__sp_steps"] h2,[id$="__sp_steps"] h3,[id$="__sp_steps"] .rte,[id$="__sp_faq"] h2,[id$="__sp_faq"] details'));
    if(!els.length)return;
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(!e.isIntersecting)return;e.target.classList.add('sp-in');io.unobserve(e.target);});
    },{threshold:.12,rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(el){
      if(el.getBoundingClientRect().top<window.innerHeight)return;
      var sibs=el.parentElement?[].indexOf.call(el.parentElement.children,el):0;
      el.style.transitionDelay=(Math.min(sibs,4)*70)+'ms';
      el.classList.add('sp-reveal');
      io.observe(el);
    });
  }

  window.spGift={sync:sync,refreshUI:refreshUI,fly:fly};

  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
  ready(function(){
    sticky();
    reveal();
    document.querySelectorAll('.cart-item__properties, .cart-items__properties, [class*="properties"]').forEach(function(el){
      if(/Free gift/i.test(el.textContent))el.setAttribute('data-sp-gift-line','');
    });
    sync().then(function(c){if(c)refreshUI();});
  });
})();
